var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPub3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7923 0H5.20898V5.20833H19.7923V0Z",
    fill: "#A7A7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15.625H6.25V25H18.75V15.625Z",
    fill: "#A7A7A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 7.29102H3.125C2.2962 7.29102 1.50134 7.62026 0.915291 8.20631C0.32924 8.79236 0 9.58721 0 10.416L0 20.8327H4.16667V13.541H20.8333V20.8327H25V10.416C25 9.58721 24.6708 8.79236 24.0847 8.20631C23.4987 7.62026 22.7038 7.29102 21.875 7.29102ZM19.7917 11.4577H15.625V9.37435H19.7917V11.4577Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPub3);
export default __webpack_public_path__ + "static/media/pub-3.426bd1bb3e8d0a828ac6305b06a3bc8d.svg";
export { ForwardRef as ReactComponent };